import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useFetchBrands from '../../hooks/brands/useFetchBrands';
import { setSelectedBrandAction } from '../../redux/actions/brandsActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import BrandsTable from './BrandsTable';
import DeleteBrandModal from './modals/DeleteBrandModal';
import UpdateBrandModal from './modals/UpdateBrandModal';

const BrandsList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, brands, refresh } = useFetchBrands({ unpaged: false });
  const [showUpdateBrandModal, setShowUpdateBrandModal] = useState(false);
  const [showDeleteBrandModal, setShowDeleteBrandModal] = useState(false);

  const handleBrandClick = (brand) => {
    navigate(`/brands/${brand.id}/models`);
  };

  const handleBrandEditClick = (brand) => {
    dispatch(setSelectedBrandAction(brand));
    setShowUpdateBrandModal(true);
  };

  const handleUpdateBrandModalSubmit = async () => {
    refresh();
    setShowUpdateBrandModal(false);
  };

  const handleBrandDeleteClick = (brand) => {
    dispatch(setSelectedBrandAction(brand));
    setShowDeleteBrandModal(true);
  };

  const handleDeleteBrandModalSubmit = async () => {
    refresh();
    setShowDeleteBrandModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateBrandModal && (
          <UpdateBrandModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdateBrandModalSubmit()}
            onModalClose={() => setShowUpdateBrandModal(false)}
          />
        )}
        {showDeleteBrandModal && (
          <DeleteBrandModal
            onModalSubmit={() => handleDeleteBrandModalSubmit()}
            onModalClose={() => setShowDeleteBrandModal(false)}
          />
        )}
        <>
          <BrandsTable
            onBrandClick={handleBrandClick}
            onBrandDeleteClick={handleBrandDeleteClick}
            onBrandEditClick={handleBrandEditClick}
            brands={brands}
            readOnly={readOnly}
            loading={loading}
          />
          {brands.length === 0 && !loading && <EmptyContent title={'Список марок автомобілів порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(BrandsList);
